import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { TranslationProviders} from './i18n.providers';
import { AppModule } from './app/app.module';
import { Config } from './environments/environment';
import { loadPlausible } from './analytics';

if (Config.production) {
  enableProdMode();
}

// A host-independent build (environment.branch.ts) ships no absolute app URL: it is the same image
// on every branch hostname, so the URL can only be known in the browser. WEB_APP_URL is the OIDC
// redirect_uri as well as the target of in-app navigation, so it must be an absolute origin.
// Environments that DO name a host are left exactly as they are.
// WEB_APP_URL_LEGACY is not filled in this way: an empty value means there is no legacy app, and
// pointing it at this origin would make the signing pages redirect an old job to themselves.
if (!Config.WEB_APP_URL) {
  Config.WEB_APP_URL = window.location.origin;
}

loadPlausible(Config.PLAUSIBLE_SCRIPT_URL, {
  captureOnLocalhost: (Config as { PLAUSIBLE_CAPTURE_ON_LOCALHOST?: boolean }).PLAUSIBLE_CAPTURE_ON_LOCALHOST === true,
});

let TP = new TranslationProviders();
TP.getTranslationFile().then((providers: any) => {
  const options: any = { providers };
  platformBrowserDynamic().bootstrapModule(AppModule, options);
});
